import { ChevronDown } from "lucide-react";
import type { ReactNode } from "react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "./collapsible";

// Base UI's Collapsible brings the aria-expanded/aria-controls wiring the
// hand-rolled version lacked. Panel keepMounted defaults to false, so closed
// content still leaves the DOM exactly as `{open && ...}` did.
export function Disclosure({
  title,
  subtitle,
  defaultOpen = true,
  children,
}: {
  title: string;
  subtitle?: string;
  defaultOpen?: boolean;
  children: ReactNode;
}) {
  return (
    <Collapsible defaultOpen={defaultOpen} className="border-t border-border first:border-t-0">
      <CollapsibleTrigger className="flex w-full cursor-pointer items-center justify-between gap-4 bg-transparent py-3.5 text-left text-foreground outline-none [&>svg]:size-4.25 [&>svg]:transition-transform [&>svg]:duration-150 data-panel-open:[&>svg]:rotate-180">
        <span className="grid gap-1">
          <strong>{title}</strong>
          {subtitle && <small className="text-xs text-muted-foreground">{subtitle}</small>}
        </span>
        <ChevronDown />
      </CollapsibleTrigger>
      <CollapsibleContent className="pb-3.5">{children}</CollapsibleContent>
    </Collapsible>
  );
}
